module.exports = __webpack_public_path__ + "images/mistergreen_smallccc04018ba10ad405ef9fdde706d21fe.png";